import React, { memo } from 'react';
import { Route, Switch } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import Solution from './#solution/Solution';
import { CSS } from './styles/css';
import useBusiness from './useBusiness';

const Business = memo(() => {
   const bsn = useBusiness()
   const { BUSINESS, NAV, SEC, BOX } = CSS

   return (
      <BUSINESS>
         <NAV Media={bsn.media}>
         {bsn.nav && bsn.nav.items.map((i, idex) =>
            <NavLink key={idex} to={i.pathname}
               activeClassName={'active'}
            >
               {i.name}
            </NavLink>
         )}
         </NAV>
         <Switch>
            <Route 
               path={'/business'} exact={true}
               render={() => (
                  <SEC Media={bsn.media}>
                     <BOX Head Media={bsn.media}>
                        <h1>최고의 기술을 향해 나아갑니다.</h1>
                        <h2>Business</h2>
                        <p>
                           {`새로운 도약, 케이데이타랩은 신기술개발과 도전정신으로\n인공지능과 빅데이터분야의 선도기업으로 성장합니다.`}
                        </p>
                        <img src={bsn.img.modern} alt="" />
                     </BOX>
                     <BOX Area Media={bsn.media}>
                        <ul>
                        {bsn.ba.map((b, bdex) => 
                           <li key={bdex} style={{ backgroundImage: `url(${b.img})` }}>
                           {b.text.map((t, tdex) => 
                              <span key={tdex}>{t}</span>
                           )}
                           </li>
                        )}
                        </ul>
                     </BOX>
                  </SEC>
               )}
            />
            <Route 
               path={'/business/bridge'} exact={true}
               render={() => (
                  <SEC Media={bsn.media}>
                     <BOX DBH Media={bsn.media}>
                        <div types={'wrap'}>
                           <h1>데이터브릿지</h1>
                           <h2>Data Bridge</h2>
                           <p>
                              {bsn.media ? `고객의 데이터와 요구조건에 맞춰진 최적의 학습용 데이터의 성성을 위한\nAI학습 데이터 클라우드 소싱 플랫폼이며\n특히 교육분야와 연동해서 학습자가\n제출한 답변과 문제로\n학습데이터를 생성합니다.` : `고객의 데이터와 요구조건에 맞춰진 최적의 학습용 데이터의 성성을 위한\nAI학습 데이터 클라우드 소싱 플랫폼이며\n특히 교육분야와 연동해서 학습자가 제출한\n답변과 문제로 학습데이터를 생성합니다.`}
                              <img src={bsn.img.analysis} alt="" />
                           </p>
                           <a href={`https://s3.ap-northeast-2.amazonaws.com/test.kdatalab/pdf/Kdatalab_data_bridge.pdf`} target={'_blank'} rel="noreferrer" download>
                              e-catalog
                           </a>
                        </div>
                     </BOX>
                     <BOX DV Media={bsn.media}>
                        <div types={'wrap'}>
                           <div types={'h'}>
                              <h1>DataVoucher</h1>
                              <h2>2021 데이터바우처지원사업</h2>
                              <p>과기부 산하 한국데이터산업진흥원(K-data)이 주관하는 ‘2021 데이터바우처 지원사업’에 데이터브릿지와 협약하고, 혜택을 받아보세요.</p>
                           </div>
                           {bsn.voucher && 
                              <div types={'voucher'}>
                                 <div>
                                    {bsn.voucher.ai.svg}
                                    <div>
                                       <h1>{bsn.voucher.ai.title}</h1>
                                       <p>{bsn.voucher.ai.explain}</p>
                                    </div>
                                 </div>
                                 <div>
                                    {bsn.voucher.normal.svg}
                                    <div>
                                       <h1>{bsn.voucher.normal.title}</h1>
                                       <p>{bsn.voucher.normal.explain}</p>
                                    </div>
                                 </div>
                              </div>
                           }
                           <div types={'ads'}>
                              <h1>데이터바우처지원사업으로 최대 7,000만원의 혜택을 받아보세요!</h1>
                              <p>한국데이터산업진흥원이 주관하는 데이터 바우처 지원사업을 확인하세요</p>
                              <a href={'https://kdata.or.kr/datavoucher/index.do'} target={'_blank'} rel={'noreferrer'}>
                                 데이터바우처 사업 공고 보기
                              </a>
                              <img src={bsn.img.manImg} alt="" />
                           </div>
                        </div>
                     </BOX>
                     <BOX AI Media={bsn.media}>
                        <div types={'wrap'}>
                           <h1>
                              <div>
                                 <span>
                                    {'AI데이터 가공'}
                                 </span>
                              </div>
                              {'인공지능 학습용 데이터 라벨링 솔루션'}
                           </h1>
                           <div types={'1'}>
                              <div>
                                 <img src={bsn.img.labeling} alt="" />
                              </div>
                              <p>
                                 <span>
                                    {'Bounding BOX'}
                                 </span>
                              </p>
                              <p>
                                 {`"이미지, 영상 데이터 속 객체를 박스로 지정하여 라벨링 합니다."`}
                              </p>
                           </div>
                           <div types={'2'}>
                              <Link to={'/contact#email'}>
                                 {`프로젝트 의뢰`}
                              </Link>
                           </div>
                           <div types={'3'}>
                              <img src={bsn.img.ex01} alt="" />
                              <img src={bsn.img.ex02} alt="" />
                           </div>
                           <div types={'4'}>
                              <div>
                                 <span>{`How it works`}</span>
                              </div>
                              {bsn.media ?
                                 <img src={bsn.img.hiwm} alt="" /> :
                                 <img src={bsn.img.hiww} alt="" />
                              }
                           </div>
                           <div types={'5'}>
                              <ul>
                              {bsn.bridge.items.map((i, idex) => 
                                 <li key={idex} style={i.shown ? { color: `rgb(37 99 246)`} : {}}
                                    onClick={() => bsn.bridge.onClick(idex)}
                                 >
                                    {i.title}
                                 </li>
                              )}
                              </ul>
                              <div>
                              {bsn.bridge.items.map((i, idex) =>
                                 i.shown && <img key={idex} src={bsn.media ? i.img[1] : i.img[0]} alt={i.title} />
                              )}
                              </div>
                           </div>
                        </div>
                     </BOX>
                     <Solution />
                  </SEC>
               )}
            />
            <Route 
               path={'/business/haccp'} exact={true}
               render={() => (
                  <SEC Media={bsn.media}>
                     <BOX Haccp Media={bsn.media}>
                        <div types={'wrap'}>
                           <div types={'intro'}>
                              <h1>스마트 해썹</h1>
                              <h2>Smart HACCP</h2>
                              <p>
                                 {
                                    'IoT, CPS를 기반으로 실시간 중요관리공정(CCP) 모니터링을 자동화하고, 각종 기록 문서를 디지털화하여, HACCP 데이터 수집·관리·분석을 가능하게 하는 실시간HACCP 종합관리시스템이 구축되고 운영되는 식품공장'
                                 }
                              </p>
                              <img src={bsn.img.haccpImg} alt="" />
                           </div>
                        </div>
                     </BOX>
                     <BOX HaccpA Media={bsn.media}>
                        <div types={'wrap'}>
                           <div types={'h'}>
                              <h1>스마트 HACCP 우대조치 조건</h1>
                              <p>
                              {
                                 '식품의약품안전처에서는 아래의 조건에 부합하는 스마트 HACCP 관리 시스템을 구축한 식품공장에는 심사를 통해 불시검사면제와 홍보 등의 우대조치가 가능한 정책을 시행합니다.\n케이데이터랩의 시스템을 사용하면 스마트 HACCP 우대조치를 받으실 수 있습니다.'
                              }
                              </p>
                           </div>
                           <div types={'b'}>
                              {bsn.haccp && bsn.haccp.items.map((i, idex) =>
                              idex % 2 === 0 ?
                              <div key={idex}>
                                 <img name={idex} src={i.img} alt="" />
                                 <div>
                                    <h1>{i.title}</h1>
                                    {i.contents.map((c, cdex) => 
                                       <p key={cdex}>
                                          { c }
                                       </p>
                                    )}
                                 </div>
                              </div> :
                              <div key={idex}>
                                 <div>
                                    <h1>{i.title}</h1>
                                    {i.contents.map((c, cdex) =>
                                       <p key={cdex}>
                                          {c}
                                       </p>
                                    )}
                                 </div>
                                 <img src={i.img} alt="" />
                              </div>
                           )}
                           </div>
                        </div>
                     </BOX>
                     <BOX HaccpB Media={bsn.media}>
                        <div types={'wrap'}>
                           <div types={'h'}>
                              <h1>스마트 HACCP 공장 구축 정부사업 신청</h1>
                              <p>
                              {
                                 '식품제조기업이 스마트공장구축 지원을 받기 위해서 아래의 방법으로\n스마트 HACCP 공급기업 케이데이터랩과 함께 정부사업 신청이 가능합니다.'
                              }
                              </p>
                           </div>
                           <div types={'b'}>
                              <div>
                                 <p>
                                 {
                                    '일반제조업 기업을 대상으로 “스마트제조혁신추진단”을 통해 스마트 HACCP공장 구축사업을 지원합니다.'
                                 }
                                 </p>
                                 <button
                                    onClick={event => {
                                       const url = 'https://www.smart-factory.kr/'
                                       window.open(url)
                                    }}
                                 >
                                    바로가기
                                 </button>
                              </div>
                              <div>
                                 <p>
                                 {
                                    '케이데이터랩은 “스마트제조혁신추진단”등록 솔루션공급기업입니다.'
                                 }
                                 </p>
                                 <button
                                    onClick={event => {
                                       const url = 'https://www.smart-factory.kr/taskAcmsltStatsSuply2/suplyInsttMtchgPopup/1?insttId=10082655'
                                       window.open(url)
                                    }}
                                 >
                                    바로가기
                                 </button>
                              </div>
                           </div>
                           <div types={'b1'}>
                              <h1>스마트 HACCP 공장 구축사업 지원 절차</h1>
                              <div>
                              {bsn.haccp.steps.map((s, sdex) => 
                                 <div key={sdex}>
                                    <div>
                                       <div>
                                          <h1>{s.title}</h1>
                                          <div>
                                             {s.text}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              )}
                              </div>
                           </div>
                           <div types={'b2'}>
                              <h1>스마트 HACCP 공장 구축사업 지원 내용</h1>
                              <div>
                                 <img src={bsn.media ? bsn.img.chartM : bsn.img.chart} alt="" />
                              </div>
                           </div>
                           <div types={'b3'}>
                              <Link to={'/contact#email'}>
                                 스마트HACCP 공장구축 상담신청
                              </Link>
                           </div>
                        </div>
                     </BOX>
                  </SEC>
               )}
            />
         </Switch>
      </BUSINESS>
   );
});

export default Business;